import { render, staticRenderFns } from "./ClassColumn.vue?vue&type=template&id=79ba910a&scoped=true"
import script from "./ClassColumn.vue?vue&type=script&lang=js"
export * from "./ClassColumn.vue?vue&type=script&lang=js"
import style0 from "./ClassColumn.vue?vue&type=style&index=0&id=79ba910a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ba910a",
  null
  
)

export default component.exports